import { useToastContext } from "components/alert/ToastContext";
import { Label } from "components/input/Label";
import Usuario from "model/administracao/cadastro/Usuario";
import AcaoAuditoria from "model/auditoria5s/auditoria/AcaoAuditoria";
import ItemClasseAuditoria from "model/auditoria5s/auditoria/ItemClasseAuditoria";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import ExecucaoAuditoriaService from "service/auditoria5s/ExecucaoAuditoriaService";

type Props = {
    visible: boolean;
    onHide: () => void;
    item: ItemClasseAuditoria;
    acao: AcaoAuditoria | null;
    onSave: (acao: AcaoAuditoria) => void
}

const execucaoAuditoriaService = new ExecucaoAuditoriaService();
export default function ModalAcaoAuditoriaCadastro(props: Props) {
    const [acao, setAcao] = useState<AcaoAuditoria>(new AcaoAuditoria());
    const [usuariosSetor, setUsuariosSetor] = useState<Usuario[]>();
    const { startLoading, stopLoading } = useLoadingContext();
    const { msgAlerta } = useToastContext();

    useEffect(() => {

        if (props.acao !== undefined && props.acao !== null) {
            setAcao(props.acao);
        } else {
            acao.itemAuditoria = props.item;
            acao.responsavel = new Usuario(0);
            acao.status = 'CRIADO';
        }

        execucaoAuditoriaService.getUsuariosSetor(props.item?.classeAuditoria?.auditoria.setor?.id || 0).then(usuarios => {
            acao.responsavel!=null && usuarios.findIndex(u => u.id === acao.responsavel?.id) === -1 && acao.responsavel.id && usuarios.push(acao.responsavel);
            setUsuariosSetor(usuarios);
        });

    }, []);

    function salvarAcao() {
        if (acao.responsavel?.id === 0) {
            msgAlerta('', 'Selecione o responsável desta ação para salvar!');
        } else {

            startLoading();
            execucaoAuditoriaService.salvarAcao(acao).then(acaoRetorno => {

                stopLoading();
                props.onSave(acaoRetorno);
                props.onHide();
            }).catch(e => {
                console.log(e);
                stopLoading();
            });

        }
    }

    return (

        <Dialog header={`Inspeção: ${acao?.itemAuditoria.nome || ""}`} visible={props.visible} onHide={() => props.onHide()} footer={<>
            <Button style={{ marginLeft: 8, marginRight: 8, marginTop: 8, color: "#FFF", backgroundColor: '#FF0000', borderWidth: 0 }} onClick={() => {
                props.onHide();
            }}>Cancelar</Button>
            <Button style={{ marginLeft: 8, marginRight: 8, backgroundColor: '#240E92' }} onClick={() => {
                salvarAcao();
            }}>Gravar ação</Button>
        </>}>

            <div style={{ backgroundColor: 'transparent' }}>

                <div style={{ display: "flex", flexDirection: "column", padding: 8, margin: 8 }}>
                    <span style={{ fontWeight: 'bold', fontSize: 18, paddingBottom: 4 }}></span>
                    <span>Status: {execucaoAuditoriaService.convertStatusAcaoString(acao.status)}</span>
                </div>

                <div style={{ display: "flex", flexDirection: "column", padding: 8, margin: 8 }}>
                    <Label style={{ paddingBottom: 4 }}>Responsável</Label>
                    <Dropdown value={acao.responsavel} placeholder="Selecione o responsável" style={{ marginTop: 1 }}
                        filter
                        options={usuariosSetor}
                        optionLabel="nome"
                        dataKey="id"
                        onChange={e => {
                            acao.responsavel = e.value;
                            setAcao({ ...acao });
                        }} />
                </div>

                <div style={{ padding: 8, margin: 8 }}>
                    <Label style={{ paddingBottom: 4 }}>Título da ação</Label>
                    <InputText
                        style={{ width: '100%' }}
                        placeholder='Título'
                        value={acao.nome}
                        onChange={(e) => {
                            acao.nome = e.target.value;
                            setAcao({ ...acao });
                        }}
                    />
                </div>

                <div style={{ padding: 8, margin: 8 }}>
                    <Label style={{ paddingBottom: 4 }}>Comentário</Label>
                    <InputTextarea
                        style={{ width: '100%' }}
                        placeholder='Descrição'
                        value={acao.descricao}
                        onChange={(e) => {
                            acao.descricao = e.target.value;
                            setAcao({ ...acao });
                        }} />
                </div>



            </div>

        </Dialog>



    );
}